import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { BsCloudUpload } from "react-icons/bs";
import { FaArrowLeft } from "react-icons/fa";
import ActionButton from "../../../Common/ActionButton";
import { InputField } from "../../../Common/FormComponents";
import { AddUOMApi, EditUOMApi } from "../../../../Api/Store/Uom";

/**
 * Add / Edit UOM Form (Stock Configuration)
 * Layout: 2 fields per row with spacer – matches AddChargeHeadingForm pattern.
 */
const AddUOM = () => {
  const history = useHistory();
  const location = useLocation();

  const populateData = location.state || {};
  const isEdit = populateData?.isEdit || false;

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    UOMName: populateData.UOMName || populateData.UomName || "",
    Abbreviation: populateData.Abbreviation || "",
    Note: populateData.Note || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!formData.UOMName.trim()) {
      toast.error("UOM Name is required");
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        uomName: formData.UOMName,
      };

      if (isEdit) {
        const res = await EditUOMApi(populateData.Id, payload);
        if (res?.data?.IsSuccess) {
          toast.success("UOM updated successfully");
          history.push("/store/configuration/uom");
        } else {
          toast.error(res?.data?.Message || "Failed to update UOM");
        }
      } else {
        const res = await AddUOMApi(payload);
        if (res?.data?.IsSuccess) {
          toast.success("UOM added successfully");
          history.push("/store/configuration/uom");
        } else {
          toast.error(res?.data?.Message || "Failed to add UOM");
        }
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {/* ── Page Header ── */}
      <div className="row">
        <div className="col-md-12 text-left page_heading">
          <div className="d-flex align-items-center">
            <FaArrowLeft
              size={16}
              style={{ cursor: "pointer", marginRight: "12px" }}
              title="Back"
              onClick={() => history.goBack()}
            />
            <h4 className="m-0">{isEdit ? "Edit" : "Add"} UOM</h4>
          </div>
        </div>
      </div>

      {/* ── Form ── */}
      <form onSubmit={handleSave} autoComplete="off">
        {/* Row 1: UOM Name | Abbreviation */}
        <div className="row">
          <InputField
            label="UOM Name:"
            name="UOMName"
            value={formData.UOMName}
            onChange={handleChange}
            required
          />

          {/* <div className="col-md-2 mt-4 p-0"></div>

          <InputField
            label="Abbreviation:"
            name="Abbreviation"
            value={formData.Abbreviation}
            onChange={handleChange}
          /> */}
        </div>

        {/* Row 2: Note */}
        {/* <div className="row">
          <TextAreaField
            label="Note:"
            name="Note"
            value={formData.Note}
            onChange={handleChange}
            rows={3}
          />
        </div> */}

        {/* ── Footer Buttons ── */}
        <div className="float-right mt-4 mr-md-3">
          <ActionButton
            text="Cancel"
            variant="cancel"
            onClick={() => history.push("/store/configuration/uom")}
          />
          <ActionButton text="Save" icon={BsCloudUpload} type="submit" isLoading={isLoading} />
        </div>
      </form>
    </div>
  );
};

export default AddUOM;
